import { CSSProperties } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { areEqual } from 'react-window';
import { memo } from 'react';

import Card from '../../Card';
import useHasPermissionToDragItem from '../../useHasPermissionToDragItem';

import { ItemModel } from '../../../../../api/boardAPI';

function getStyle({
  draggableStyle,
  virtualStyle,
}: {
  draggableStyle: CSSProperties;
  virtualStyle: CSSProperties;
}) {
  const combined = {
    ...virtualStyle,
    ...draggableStyle,
  };

  const marginBottom = 10;
  const result = {
    height: (combined.height as number) - marginBottom,
    ...combined,
    left: combined.left,
    width: '100%',
    marginBottom: marginBottom,
  };
  return result;
}

const Row = memo(function Row(props: { data: ItemModel[]; index: number; style: CSSProperties }) {
  const { data: items, index, style } = props;
  const item = items[index];
  const hasPermissionToDragItem = useHasPermissionToDragItem();

  // We are rendering an extra item for the placeholder
  // for more details check the react-beautiful-dnd doc
  // https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md
  if (!item) {
    return null;
  }

  const isDragDisabled = !hasPermissionToDragItem(item.typeUuid);

  return (
    <Draggable
      key={item.uuid}
      draggableId={item.uuid}
      index={index}
      isDragDisabled={isDragDisabled}
    >
      {(provided) => {
        return (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            key={item.uuid}
            style={getStyle({
              draggableStyle: provided.draggableProps.style,
              virtualStyle: style,
            })}
          >
            <Card columnId={item.columnUuid} uuid={item.uuid} contactUuid={item.typeUuid} />
          </div>
        );
      }}
    </Draggable>
  );
}, areEqual);

export default Row;
